<template>
  <div class="home">
    <img
      src="../assets/stork.svg"
      alt="un triangle aux trois côtés égaux"
      height="200rem"
      width="200rem"
    />

    <!-- <LandingMessage /> -->
    <b-jumbotron
      header="Bienvenue"
      lead="Essaie de trouver le sexe et le prénom de notre enfant !"
    >
      <router-link class="btn btn-primary" to="/play">Participer</router-link>
      <router-link class="btn btn-light" to="/statistics"
        >Statistiques</router-link
      >
    </b-jumbotron>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "Home",
};
</script>
